/**
 * HOMEPAGE ARCHIVE: Legacy Version (V1)
 * Last active: December 2024
 * Decommissioned: December 18, 2024
 * 
 * The SMB-focused homepage with form-based lead capture.
 * Targeted £500-£1,000/month clients.
 * Replaced by HomeV2 (B2B Enterprise focus).
 */

import Hero from "@/components/Hero";
import ChallengeOpportunity from "@/components/ChallengeOpportunity";
import WebsiteAudit from "@/components/WebsiteAudit";
import HowWeHelp from "@/components/HowWeHelp";
import WebsiteCTA from "@/components/WebsiteCTA";
import Testimonials from "@/components/Testimonials";
import EnhancedSEO from "@/components/SEO/EnhancedSEO";

const HomeLegacy = () => {
  return (
    <>
      <EnhancedSEO 
        type="homepage"
        title="VGP | Premium Expert Marketing - Scale Your Business With Proven SEO & Lead Generation"
        description="We help premium businesses attract high-value clients through targeted marketing strategies. Transform your client base with our proven SEO and lead generation systems that deliver 150% average revenue increases."
        keywords="premium marketing, SEO services, lead generation, digital growth, business scaling, high-ticket clients, revenue growth, digital marketing agency UK"
        url="/archive/home-legacy"
      />
      <div className="min-h-screen bg-background">
        {/* Archive Notice Banner */}
        <div className="bg-amber-500/90 text-amber-950 py-3 px-4 text-center font-medium">
          <span className="text-sm">📦 Archive: Legacy Homepage V1 (Decommissioned Dec 18, 2024) — </span>
          <a href="/" className="underline hover:no-underline">View Current Site →</a>
        </div>
        <Hero />
        <ChallengeOpportunity />
        <WebsiteAudit />
        <HowWeHelp />
        <WebsiteCTA />
        <Testimonials />
      </div>
    </>
  );
};

export default HomeLegacy;
